/**
 * by zhang.qiang 2016-10-26
 */
"use strict";
angular.module('manageSysManagePlanDispatchModule', ['newWindowPlanDispatchZhuangtaiCtrlModule', 'newWindowPlanDispatchLeiXingModule'])
    .controller('manageSysManagePlanDispatchCtrl', ['$scope', '$q', '$modal', 'trsHttpService', 'globleParamsSet', 'modalDialog', 'trsspliceString', function($scope, $q, $modal, trsHttpService, globleParamsSet, modalDialog, trsspliceString) {
        initStatus();
        initData();
        /**
         * [initStatus description] 默认状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": 20,
                "ITEMCOUNT": 0,
                "PAGECOUNT": 1
            };
            $scope.status = {
                params: {
                    serviceid: "mlf_jobworkertype",
                    methodname: "queryJobWorkerTypes",
                    OpName: "",
                    CURRPAGE: $scope.page.CURRPAGE,
                    PAGESIZE: $scope.page.PAGESIZE,
                },
                copyCurrPage: 1,
                isESSearch: false,
                queryRenwu: false,
            };
            $scope.data = {
                items: [],
                selectedArray: []
            };
        }
        /**
         * [initData description] 默认数据
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }
        /**
         * [requestData description]请求数据
         * @return {[type]} [description]
         */
        function requestData() {
            var params = {
                serviceid: "mlf_jobworkertype",
                methodname: "queryOperTypeScheduleList",
                JobWorkerTypeId: $scope.OPERID, //$scope.OPERID 为传入类型的ID
                SchName: $scope.keywords
            };
            params = $scope.status.queryRenwu ? params : $scope.status.params;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.items = data.DATA;
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                $scope.page.PAGESIZE = data.PAGER.PAGESIZE;
                $scope.data.selectedArray = [];
            });
        }

        /**
         * [new description]新建
         * @return {[type]} [description]
         */
        $scope.new = function() {
            $scope.status.isESSearch = false;
            $scope.status.params.SchName = ""; //新建后，显示未检索数据
            if ($scope.status.queryRenwu === false) {
                createOrEdit({ OPERID: 0 }, "新建"); // 新建 类型
            } else {
                requestNewRenWuData();
                createOrEdit({ SCHID: 0, OPNAMES: $scope.OPNAMES, Canshu: $scope.NewCanshu }, "新建"); // 新建 状态
            }
        };
        /**
         * [xiugai 修改]
         * @return {[type]} [description]
         */
        $scope.xiugai = function(item) {
            if ($scope.status.queryRenwu === true) {
                requestRenWuData(item).then(function(data) {
                    item.OPNAMES = $scope.OPNAMES;
                    createOrEdit(item, "修改");
                });
            } else {
                item.OPNAMES = $scope.OPNAMES;
                createOrEdit(item, "修改");
            }
        };
        /**
         * [createOrEdit 新建或修改]
         * @param  {[object]} item [description] 修改对象
         * @param  {[string]} type [description] 类型
         * @return {[type]} [description]
         */
        function createOrEdit(item, type) {
            if ($scope.status.queryRenwu === false) {
                //类型 新建修改请求
                windowOpenleixing(item, function(result) {
                    var params = {
                        serviceid: "mlf_jobworkertype",
                        methodname: "saveJobWorkerType",
                        JobWorkerTypeId: item.OPERID,
                        OpName: result.OPNAME,
                        OpDesc: result.OPDESC,
                        Param: result.PARAM,
                        OpBean: result.OPBEAN,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get", true).then(function(data) {
                        modalDialog.alertType(type + '成功', "", "success", false, function() {
                            requestData();
                            $scope.data.selectedArray = [];
                        });
                    }, function(data) {
                        if (data.code === "10") {
                            modalDialog.alertType(type + "失败", "没有找到" + result.OPBEAN + "对应的类", "error", false, function() {
                                requestData();
                            });
                        } else {
                            modalDialog.alertType(data.message, data.detail, "error", false, function() {
                                requestData();
                            });
                        }
                    });
                });
            } else {
                //任务 新建修改请求
                windowOpenZhuangTai(item, function(result) {
                    var params = {
                        serviceid: "mlf_schedule",
                        methodname: "saveSchedule",
                        ScheduleId: item.SCHID,
                        SchName: result.SCHNAME,
                        SchDesc: result.SCHDESC,
                        OpGres: result.OPARGS,
                        TypeId: $scope.OPERID,
                        SchMode: result.SCHMODE,
                        interval: result.PARAM,
                        sDate: result.SDATE,
                        eDate: result.EDATE,
                        exeDate: result.ETIME
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get", true).then(function(data) {
                        modalDialog.alertType(type + '成功', "", "success", false, function() {
                            requestData();
                            $scope.data.selectedArray = [];
                        });
                    });
                });
            }
        }
        /**
         * [requestNewRenWuData 新建时请求新建任务的参数]
         * @return {[type]} [description]
         */
        function requestNewRenWuData() {
            var params = {
                serviceid: "mlf_schedule",
                methodname: "getJobWorkerTypeParam",
                OperId: $scope.OPERID, //$scope.OPERID 为传入类型的ID
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get", true).then(function(data) {
                $scope.NewCanshu = data; //给item 添加canshu传入任务数据
            });
        }
        /**
         * [requestRenWuData 请求任务参数]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        function requestRenWuData(item) {
            var defer = $q.defer();
            var params = {
                serviceid: "mlf_schedule",
                methodname: "getScheduleOpargs",
                OperId: $scope.OPERID, //$scope.OPERID 为传入类型的ID
                SchId: item.SCHID
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get", true).then(function(data) {
                item.Canshu = data; //给item 添加canshu传入任务数据
                defer.resolve(data);
            });
            return defer.promise;
        }
        /**
         * [windowOpen description] 新建修改 状态 弹窗
         * @return {[type]} [description]
         */
        function windowOpenZhuangTai(item, success) {
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/sysManageMent/PlanDispatch/newWindowPlanDispatchZhuangtai/newWindowPlanDispatchZhuangtai_tpl.html",
                scope: $scope,
                windowClass: 'new-window-plan-dispatch-zhuangtai',
                backdrop: true,
                controller: "newWindowPlanDispatchZhuangtaiCtrl",
                resolve: {
                    Params: function() {
                        return item;
                    }
                },
            });
            modalInstance.result.then(function(result) {
                success(result);
            });
        }
        /**
         * [windowOpenleixing description] 新建修改 类型 弹窗
         * @param  {[type]} item    [description]
         * @param  {[type]} success [description]
         * @return {[type]}         [description]
         */
        function windowOpenleixing(item, success) {
            var modalInstance = $modal.open({
                templateUrl: "./manageConfig/sysManageMent/PlanDispatch/newWindowPlanDispatchLeixing/newWindowPlanDispatchLeixing_tpl.html",
                scope: $scope,
                windowClass: 'new-window-plan-dispatch-leixing',
                backdrop: true,
                controller: "newWindowPlanDispatchLeiXingCtrl",
                resolve: {
                    Params: function() {
                        return item;
                    }
                },
            });
            modalInstance.result.then(function(result) {
                success(result);
            });
        }
        /**
         * [shareDraft description]删除
         * @return {[type]} [description]
         */
        $scope.shareDraft = function() {
            modalDialog.confirmModal('删除', '确定删除所选类型', function() {
                if ($scope.status.queryRenwu === false) {
                    var params = {
                        serviceid: "mlf_jobworkertype",
                        methodname: "delJobWorkerType",
                        JobWorkerTypeIds: trsspliceString.spliceString($scope.data.selectedArray, "OPERID", ","),
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        requestData();
                        $scope.data.selectedArray = [];
                    });
                } else {
                    var paramss = {
                        serviceid: "mlf_schedule",
                        methodname: "delSchedules",
                        SchIds: trsspliceString.spliceString($scope.data.selectedArray, "SCHID", ","),
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), paramss, 'get').then(function(data) {
                        requestData();
                        $scope.data.selectedArray = [];
                    });
                }
            });
        };
        /**
         * [fanHui 返回到类型页面]
         * @return {[type]} [description]
         */
        $scope.fanHui = function() {
            $scope.status.queryRenwu = false;
            $scope.status.isESSearch = false;
            $scope.status.params.OpName = ""; //处理在任务页面的搜索参数
            $scope.keywords = ""; //处理在任务页面的搜索参数
            requestData();
            $scope.data.selectedArray = [];
        };
        /**
         * [chaKanRenWu 进入任务页面]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.chaKanRenWu = function(item) {
            $scope.status.queryRenwu = true;
            $scope.keywords = "";
            $scope.OPERID = item.OPERID; //$scope.OPERID 为传入类型的ID
            $scope.OPNAMES = item.OPNAME; //$scope.OPNAMES 为传入类型的名字
            requestNewRenWuData();
            requestData();
            $scope.data.selectedArray = [];
        };
        /**
         * [fullTextSearch 检索]
         * @return {[type]} [description]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                if ($scope.keywords == " ") {
                    $scope.status.isESSearch = false;
                } else {
                    $scope.status.isESSearch = true;
                    $scope.status.params.OpName = $scope.keywords;
                }
                $scope.page.CURRPAGE = 1;
                $scope.status.copyCurrPage = 1;
                requestData();
            }
        };
        /**
         * [refresh description]刷新
         * @return {[type]} [description]
         */
        $scope.refresh = function() {
            $scope.status.isESSearch = false;
            if ($scope.status.queryRenwu === true) {
                requestNewRenWuData();
            }
            $scope.status.params.SchName = ""; //刷新后，显示未检索数据
            $scope.status.params.CURRPAGE = $scope.page.CURRPAGE = 1;
            $scope.status.copyCurrPage = 1;
            requestData();
        };
        /**
         * [selectAll description] 列表全选按钮
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };
        /**
         * [selectDoc description] 列表单选按钮
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };
        /** [selectPageNum description] 每页显示的数据数量
         */
        $scope.selectPageNum = function() {
            $scope.status.copyCurrPage = 1;
            $scope.status.params.PageSize = $scope.page.PAGESIZE;
            $scope.status.params.CURRPAGE = $scope.page.CURRPAGE;
            requestData();
        };
        /**
         * [selectPageNum description] 选择一页要显示的数据量
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function() {
            $scope.status.copyCurrPage = 1;
            $scope.status.params.PageSize = $scope.page.PAGESIZE;
            $scope.status.params.CURRPAGE = $scope.page.CURRPAGE;
            requestData();
        };
        /**
         * [pageChanged description] 下一页 页面改变调取数据
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.status.params.CURRPAGE = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };
        /**
         * [jumpToPage description] 跳转页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGESIZE) {
                $scope.status.CURRPAGE = $scope.page.PAGESIZE;
            }
            $scope.status.params.CURRPAGE = $scope.status.copyCurrPage;
            $scope.page.CURRPAGE = $scope.status.params.CURRPAGE;
            requestData();
        };
    }]);
